<template>
    <section class="bigCourseCard" @click="goto(data.innerid)" v-if="data.coverurl">

        <div class="img">
            <img v-lazy="data.coverurl" :alt="data.subject">
        </div>
        <div class="text">
            <p class="title">{{data.subject}}</p>
            <div>
                <p class="nums">
                    <template  v-if="data.feetype == 2"> 
                        <span class="text_money">￥{{data.saleprice}}</span>
                        <span class="text_underline_money">￥{{data.uprice}}</span>
                        <span class="limit-box" v-if="data.islimitcount">限时折扣</span>
                    </template>
                    <template v-else>
                        <span class="text_money">免费</span>
                    </template>
                </p>
                <!--<p><span class="text_participant">{{data.joincount}}人参与</span></p>-->
            </div>
        </div>
    </section>
</template>

<script>
import {mapGetters} from 'vuex'
export default {
    name: 'bigCourseCard',
    props: ['data'],
    mounted() {},
    methods: {
        goto(id) {
        // 判断是课程还是题库 7课程 8题库
            if (this.data.kmctype == 8) {
              const { href } = this.$router.resolve({
                name: "QuestionDetails",
                query: {
                    qid: id
                }
              })
              window.open(href, '_blank');
            } else {
              const { href } = this.$router.resolve({
                name: "CourseDetails",
                query: {
                    cid: id,
                    chid: this.channelid
                }
              })
              window.open(href, '_blank');
            }
             
            // this.$router.push({name: 'CourseDetails', query: {'cid': id}})
        }
    },
    computed: {
        ...mapGetters([
            'channelid'
        ])
    }
}
</script>

<style lang="scss" type="text/scss">
.bigCourseCard {
    width: 384px;
    height: 337px;
    border-radius:4px;
    cursor: pointer;
    background: #F8F7F7;
    .limit-box{
        width: 64px;
        height: 20px;
        border-radius: 4px;
        border: 1px solid #FF4747;
        color: #FF4747;
        font-size: 12px;
        display: flex;
        justify-content: center;
        align-items: center;
        box-sizing: border-box;
        margin-left: 12px;
    }
    .img {
        width: 384px;
        height: 216px;
        overflow: hidden;
        border-top-left-radius:4px;
        border-top-right-radius: 4px;
        background: #E5E5E5;

        img {
            transition: all .5s;
            -moz-transition: all .5s;
            -o-transition: all .5s;
            -ms-transition: all .5s;
            -webkit-transition: all .5s;
            width: 100%;
            height: 100%;
        }
    }

    &:hover img {
        transition: all .5s;
        -moz-transition: all .5s;
        -o-transition: all .5s;
        -ms-transition: all .5s;
        -webkit-transition: all .5s;
        transform: scale(1.2);
        -moz-transform: scale(1.2);
        -o-transform: scale(1.2);
        -ms-transform: scale(1.2);
        -webkit-transform: scale(1.2);
    }


    .text {
        padding: 20px;
        box-sizing: border-box;

        .title {
            font-size: 20px;
            color: #333;
            min-height: 52px;
            line-height: 26px;
            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            word-break:break-all;
        }

        div {
            margin-top: 14px;
        }
        span {
            line-height: 18px;
        }
        .nums {
            padding-top: 0;
            display: flex;
            align-items: center;
        }
        .text_money {
            margin-right: 6px;
            color: #FF4747;
            font-size: 18px;
        }
        .text_participant,
        .text_underline_money {
            color: #999;
            font-size: 14px;
        }
        .text_underline_money {
            text-decoration: line-through
        }
        .text_participant {
            /*float: right;*/
        }
    }
}
</style>